export default {
  'pages.system.menu.title': '菜单管理',
  'pages.system.menu.name': '菜单名称',
  'pages.system.menu.path': '路径',
  'pages.system.menu.icon': '图标',
  'pages.system.menu.order': '排序',
  'pages.system.menu.enabled': '是否启用',
  'pages.system.menu.add': '新增菜单',
  'pages.system.menu.edit': '编辑菜单',
  'pages.system.menu.delete': '删除',
  'pages.system.menu.confirm': '确认删除',
  'pages.system.menu.confirmContent': '确定要删除这个菜单吗？',
  'pages.system.menu.deleteSuccess': '删除成功',
  'pages.system.menu.updateSuccess': '更新成功',
  'pages.system.menu.addSuccess': '添加成功',
  'pages.system.menu.namePlaceholder': '请输入菜单名称',
  'pages.system.menu.pathPlaceholder': '请输入路径',
  'pages.system.menu.iconPlaceholder': '请输入图标名称',
  'pages.system.menu.orderPlaceholder': '请输入排序号',
  'pages.system.menu.nameRequired': '请输入菜单名称',
  'pages.system.menu.pathRequired': '请输入路径',
  'pages.system.menu.iconRequired': '请输入图标',
  'pages.system.menu.orderRequired': '请输入排序号',
  'pages.system.menu.enable': '启用',
  'pages.system.menu.disable': '禁用',
  'pages.system.menu.cancel': '取消',
  'pages.system.menu.submit': '提交',

  'pages.system.user.title': '用户管理',
  'pages.system.user.username': '用户名',
  'pages.system.user.email': '邮箱',
  'pages.system.user.phone': '电话',
  'pages.system.user.role': '角色',
  'pages.system.user.status': '状态',
  'pages.system.user.add': '新增用户',
  'pages.system.user.edit': '编辑用户',
  'pages.system.user.delete': '删除',
  'pages.system.user.confirm': '确认删除',
  'pages.system.user.confirmContent': '确定要删除这个用户吗？',
  'pages.system.user.deleteSuccess': '删除成功',
  'pages.system.user.updateSuccess': '更新成功',
  'pages.system.user.addSuccess': '添加成功',
  'pages.system.user.usernamePlaceholder': '请输入用户名',
  'pages.system.user.emailPlaceholder': '请输入邮箱',
  'pages.system.user.phonePlaceholder': '请输入电话',
  'pages.system.user.usernameRequired': '请输入用户名',
  'pages.system.user.emailRequired': '请输入邮箱',
  'pages.system.user.emailInvalid': '邮箱格式不正确',
  'pages.system.user.phoneRequired': '请输入电话',
  'pages.system.user.roleRequired': '请选择角色',
  'pages.system.user.statusRequired': '请选择状态',
  'pages.system.user.admin': '管理员',
  'pages.system.user.normalUser': '普通用户',
  'pages.system.user.enable': '启用',
  'pages.system.user.disable': '禁用',
  'pages.system.user.cancel': '取消',
  'pages.system.user.submit': '提交',

  'pages.system.role.title': '角色管理',
  'pages.system.role.name': '角色名称',
  'pages.system.role.description': '描述',
  'pages.system.role.permissions': '权限数',
  'pages.system.role.add': '新增角色',
  'pages.system.role.edit': '编辑角色',
  'pages.system.role.delete': '删除',
  'pages.system.role.confirm': '确认删除',
  'pages.system.role.confirmContent': '确定要删除这个角色吗？',
  'pages.system.role.deleteSuccess': '删除成功',
  'pages.system.role.updateSuccess': '更新成功',
  'pages.system.role.addSuccess': '添加成功',
  'pages.system.role.namePlaceholder': '请输入角色名称',
  'pages.system.role.descriptionPlaceholder': '请输入描述',
  'pages.system.role.nameRequired': '请输入角色名称',
  'pages.system.role.descriptionRequired': '请输入描述',
  'pages.system.role.permissionsRequired': '请选择至少一个权限',
  'pages.system.role.permissionConfig': '权限配置',
  'pages.system.role.cancel': '取消',
  'pages.system.role.submit': '提交',
};
